module.exports = __webpack_public_path__ + "7655d2f42787c0c63dda9d4cd187976b.png";